export { API, BACKEND_URL } from '@/config/api';
export const getInstructions = (sampleType, depth) => {
  if (sampleType === 'algae') {
    return {
      title: 'Instruksjoner for algeprøve',
      steps: [
        {
          title: 'Utstyr',
          desc: 'Bruk rent prøveutstyr. Unngå forurensning fra andre prøver.'
        },
        {
          title: 'Prøvetaking',
          desc: `Ta prøve på ${depth || '3m'} dybde. Bruk vannhenter eller tilsvarende utstyr.`
        },
        {
          title: 'Håndtering',
          desc: 'Fyll prøveflasken helt opp. Ikke bland prøver fra forskjellige lokaliteter.'
        },
        {
          title: 'Merking',
          desc: 'Merk flasken tydelig med: Dato, Lokalitet, Dybde, Tidspunkt.'
        },
        {
          title: 'Oppbevaring',
          desc: 'Oppbevar prøven mørkt og kjølig (2-8°C). Ikke fryse!'
        },
        {
          title: 'Forsendelse',
          desc: 'Send prøven til laboratoriet innen 24 timer. Bruk kjøleboks ved frakt.'
        }
      ]
    };
  } else {
    return {
      title: 'Instruksjoner for zooplanktonprøve',
      steps: [
        {
          title: 'Utstyr',
          desc: 'Bruk håv med maskevidde 90-200 µm. Sjekk at håven er hel og ren.'
        },
        {
          title: 'Prøvetaking',
          desc: 'Ta vertikalt håvtrekk fra bunn til overflate. Noter dybdespenn.'
        },
        {
          title: 'Tøm håven',
          desc: 'Skyll zooplankton ned i samlebeholder. Bruk litt sjøvann til skylling.'
        },
        {
          title: 'Konservering',
          desc: 'Konserver med 4% formalin eller 70% etanol. Forhold 1:3 (prøve:konserveringsmiddel).'
        },
        {
          title: 'Merking',
          desc: 'Merk beholder med: Dato, Lokalitet, Dybdespenn, Håvtype, Tidspunkt.'
        },
        {
          title: 'Oppbevaring',
          desc: 'Oppbevar mørkt og kjølig. Unngå direkte sollys. Ikke fryse!'
        },
        {
          title: 'Sikkerhet',
          desc: '⚠️ Formalin er giftig! Bruk hansker og god ventilasjon ved håndtering.'
        }
      ]
    };
  }
};
